import { useSelectModalStore } from "pages/Common/AppState";
import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import "./AppModal.scss";

const AppSelectModal = () => {
  const { closeModal } = useSelectModalStore();
  const isOpen = useSelectModalStore((state) => state.isOpen);
  const header = useSelectModalStore((state) => state.header);
  const content = useSelectModalStore((state) => state.content);
  const onCancel = useSelectModalStore((state) => state.onCancel);
  const onConfirm = useSelectModalStore((state) => state.onConfirm);
  const cancelText = useSelectModalStore((state) => state.cancelText);
  const confirmText = useSelectModalStore((state) => state.confirmText);
  return (
    <Modal
      isOpen={isOpen}
      centered
      toggle={closeModal}
      className="app-modal"
      container={document.getElementById("mobile-landing-container")}
    >
      {header && <ModalHeader tag={"div"}>{header}</ModalHeader>}
      <ModalBody>{content}</ModalBody>
      <ModalFooter
        className="m-0 p-0"
        onClick={() => {
          closeModal();
          onCancel?.();
        }}
      >
        <div className="flex-row-between align-items-center width-100 height-100 m-0 p-0">
          <div
            className="flex-col-center width-50 height-100 bg-color-lighter-gray"
            type="button"
            color="secondary"
            onClick={() => {
              closeModal();
              onCancel?.();
            }}
          >
            <span className="text-black fw-300">{cancelText || "취소"}</span>
          </div>
          <div
            className="flex-col-center width-50 height-100"
            type="button"
            color="primary"
            onClick={() => {
              closeModal();
              onConfirm?.();
            }}
          >
            <span className="fw-300">{confirmText || "확인"}</span>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default AppSelectModal;
